export var SalesPaginatedListReportMapper = function (data) {
    var groupListEntity = {
        groupList: [],
        data: []
    };
    // if (data && data?.length > 0) {
    //     data.map((record) => {
    //         let groupListSubEntity: ISalesPaginatedGroupListEntity = {
    //             groupName: record.kpi_group,
    //             id: record.kpi_id,
    //             name: record.kpi_name
    //         }
    //         groupListEntity.data.push(groupListSubEntity);
    //     });
    //     let groupList: Array<string> = [];
    //     data.map((record) => {
    //         if (!groupList.includes(record.kpi_group)) {
    //             groupList.push(record.kpi_group);
    //             let groupEntityRecord: ISalesPaginatedListGroupReportEntity = {
    //                 groupName: record.kpi_group,
    //                 subReportGroupList: []
    //             }
    //             groupListEntity.groupList.push(groupEntityRecord);
    //         }
    //     });
    //     groupListEntity.groupList = groupListEntity.groupList.map((record) => {
    //         data.filter((subRecord) => subRecord.kpi_group === record.groupName).map((subRecord) => {
    //             let subGroupRecord: ISalesPaginatedListSubGroupReportEntity = {
    //                 id: subRecord.kpi_id,
    //                 name: subRecord.kpi_name
    //             }
    //             record.subReportGroupList.push(subGroupRecord);
    //         })
    //         return record;
    //     });
    // }
    return groupListEntity;
};
